// extracted by mini-css-extract-plugin
export default {"mapButton":"MapButton_mapButton__OTlku","left":"MapButton_left__mtcU5","middle":"MapButton_middle__yQT+W","right":"MapButton_right__7NcM9"};